<template>
  <section class="s-carousel">
    <div class="carousel-indicator" data-indicator>
      <svg class="indicator" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="outer" d="M48 95.5C74.2335 95.5 95.5 74.2335 95.5 48C95.5 21.7665 74.2335 0.5 48 0.5C21.7665 0.5 0.5 21.7665 0.5 48C0.5 74.2335 21.7665 95.5 48 95.5Z" fill="#DBDBDB" stroke="#383838" stroke-miterlimit="10" />
        <path class="inner" d="M47.5 67.5C58.5457 67.5 67.5 58.5457 67.5 47.5C67.5 36.4543 58.5457 27.5 47.5 27.5C36.4543 27.5 27.5 36.4543 27.5 47.5C27.5 58.5457 36.4543 67.5 47.5 67.5Z" fill="#E8E8E8" />
        <path class="arrow" d="M46.2 42.2L51.4 47.4L46.2 52.6" stroke="#383838" stroke-miterlimit="10" />
      </svg>
    </div>
    <div class="carousel-container">
      <h2 v-html="lang === 'it' ? 'Metodo' : 'Method'"></h2>
      <div class="carousel-item">
        <div class="carousel-block">
          <h4 v-html="data.slides[0].h4"></h4>
          <ul>
            <li v-for="(item, i) in data.slides[0].ul" :key="i" v-html="item"></li>
          </ul>
        </div>
      </div>
      <div class="carousel-item">
        <div class="carousel-block">
          <h4 v-html="data.slides[1].h4"></h4>
          <ul>
            <li v-for="(item, i) in data.slides[1].ul" :key="i" v-html="item"></li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { app } from '@/utils/store';
import Carousel from './carousel';
import nodata from './data';

let carousel;
const data = nodata[app.language];

export default {
  data() {
    return {
      lang: app.language,
      data,
    };
  },
  mounted() {
    carousel = new Carousel();
    carousel.init();
  },
};
</script>
